import React from "react";
import LeadsTableBody from "./LeadsTableBody";

/**
 * Wrapper for rendering Training Leads rows.
 */
function TrainingLeadsTable(props) {
  return <LeadsTableBody {...props} activeTab="Training Leads" />;
}

export default TrainingLeadsTable;

